import React, { useEffect } from 'react'
import * as tabStyles from '../../styles/project-modules/bills/tabs.module.less'

function Tabs({ sections, activeView, setActiveView, location }) {
  //TO DO: FINISH HANDLING KEYBOARD EVENTS
  //https://inclusive-components.design/tabbed-interfaces/

  function handleTabChange(event, section) {
    event.preventDefault()
    //handling keyboard tab
    if (event.type === 'keydown') {
      let dir = event.which === 37 ? 'left' : 39 ? 'right' : 40 ? 'down' : null
      if (dir === 'down') {
        document.querySelector(`#section-${section.key}`).focus()
      } else if (dir) {
        setActiveView(section.key)
      }
    } else {
      setActiveView(section.key)
    }
  }

  //update hash when we swap so folks can send each other different views
  useEffect(() => {
    if (activeView && window.history) {
      window.history.replaceState({}, '', `#${activeView}`)
    }

    return () => {
      // cleanup
    }
  }, [activeView])

  return (
    <nav className={tabStyles.container}>
      <ul className={tabStyles.list} role="tablist">
        {sections.map((section) => {
          const isActive = activeView === section.key
          return (
            <li key={section.key} role="presentation">
              <a
                role="tab"
                href={`#section-${section.key}`}
                id={`tab-${section.key}`}
                tabindex={isActive ? -1 : 0}
                aria-selected={isActive}
                onClick={(e) => handleTabChange(e, section)}
                className={tabStyles.tab}
              >
                {section.label}
              </a>
            </li>
          )
        })}
      </ul>
    </nav>
  )
}

export default Tabs
